import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import personFill from '@iconify/icons-eva/person-fill';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import clubFill from '@iconify/icons-ic/baseline-badge';
import starBox from '@iconify/icons-mdi/star-box';

import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, MenuItem, Typography, Avatar, IconButton } from '@mui/material';
// components
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import MenuPopover from '../../components/MenuPopover';
//
import { sessionActions } from '../../store';
import { useTranslation } from '../../common/LocalizationProvider';
import { createWithQuery } from '../../fetch';
import {
  selectAbonnementData,
  selectGroupSelectedId,
  selectSession
} from '../../createSelectorUtils';
// ----------------------------------------------------------------------

export default function AccountPopover() {
  const t = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const anchorRef = useRef(null);

  const MENU_OPTIONS = [
    {
      label: t('accountPopover_Home'),
      icon: homeFill,
      linkTo: '/'
    },
    {
      label: t('profile'),
      icon: personFill,
      linkTo: '/profile'
    },
    {
      label: t('myClub'),
      icon: clubFill,
      linkTo: '/myclub'
    },
    {
      label: t('settings'),
      icon: settings2Fill,
      linkTo: '/profile/settings'
    }
  ];

  const { enqueueSnackbar } = useSnackbar();
  const abonnement = useSelector(selectAbonnementData);
  const session = useSelector(selectSession);
  const groupId = useSelector(selectGroupSelectedId);
  const permission = session.permission
    ? session.permission.find((item) => item.groupid === groupId) || {}
    : {};

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    fetch('/api/session', { method: 'DELETE' }).then((response) => {
      if (response.ok) {
        dispatch(sessionActions.abonnement(false));
        dispatch(sessionActions.authenticated(false));
        window.localStorage.clear();
        navigate('/login', { replace: false });
        window.location.reload();
      }
    });
  };

  const handleAbonnement = async () => {
    const response = await createWithQuery('abonnement/review');
    if (response.ok) {
      window.location.href = await response.text();
    } else {
      const message = await response.text();
      enqueueSnackbar(message, { variant: 'error' });
    }
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <Avatar src={session.userImage} alt="photoURL" />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {`${session.prenom} ${session.name}`}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {session.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        {(permission.status === 3 || permission.status === 4 || groupId === 0) &&
          abonnement &&
          !session.administrator && (
            <MenuItem
              key="abonnement"
              onClick={handleAbonnement}
              sx={{ typography: 'body2', py: 1, px: 2.5 }}
            >
              <Box
                component={Icon}
                icon={starBox}
                sx={{
                  mr: 2,
                  width: 24,
                  height: 24
                }}
              />

              {t('subscription')}
            </MenuItem>
          )}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button fullWidth color="inherit" variant="outlined" onClick={handleLogout}>
            {t('accountPopover_Logout')}
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
